import styled from 'styled-components';

const JBPStyled = styled.div`
  .top-section{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 48px;
    .button-section{
      display: flex;
      .create-btn{
        margin-left: 8px;
      }
    }
  }
`;

export default JBPStyled;
